import { Box, Typography } from '@mui/material';

export function ResultBox({ value, showBorder = true }) {
  return (
    <Box sx={{ border: showBorder ? '1px solid black' : 'none', padding: '5px', minWidth: '50px', display: 'flex', justifyContent: 'center' }}>
      <Typography variant="h6" color="textPrimary" component="h6">
        {value}
      </Typography>
    </Box>
  );
}
